import { LDObject } from 'emt-library'
import { capitalizeSentence, uncapitalizeSentence } from '@/utils'

export type Insurance = LDObject<'Insurance'> & {
  id: string
  name: string
  position: number
  regex: string
  logo: string
  premium: boolean
  duration: number
  slug: string
  inlineLogo: string
  prefix: string

  displayName?: string // Only used for local static items

  hasHelper: boolean

  identifierName: string
  attemptValidation: boolean
  attempts: number
  redirectToQuote: boolean
  affiliationSuccessWebContentIRI: string // IRI

  uniqueAffliliation?: boolean
}

export type PartnerQuote = LDObject<'PartnerQuote'> & {
  slug: string
  name: string
  logo: string
  inlineLogo: string
  prefix: string
  prospectWebContentIRI: string
}

export type PartnerQuoteProspect = LDObject<'PartnerQuote'> & {
  createdAt: string
  updatedAt: string
  id: string
  customer: string
  partner: string
  deleted: boolean
}

export type CustomerInsurance = LDObject<'CustomerInsurance'> & {
  rejectedAt: string
  validatedAt: string
  insurance: Insurance
}

export const getInsurancePrefix = (insurance: Insurance | null, uppercaseFirstLetter = false): string => {
  if (insurance?.prefix?.length) {
    if (uppercaseFirstLetter) {
      return capitalizeSentence(insurance.prefix)
    }
    return insurance.prefix
  }

  return ''
}

export enum TextTransformOption {
  None = 'none',
  Lowercase = 'lowercase',
  Capitalize = 'capitalize',
  Uppercase = 'uppercase',
}

export type InsurancePatternsInfo = {
  patterns: number[]
  valueSeparator: string
  placeholders: string[]
  textTransform: TextTransformOption
}

export const getInsurancePatternInfos = (insurance?: Insurance): InsurancePatternsInfo => {
  if (insurance?.slug === 'matmut') {
    return {
      patterns: [12, 1],
      valueSeparator: '',
      placeholders: ['XXXXXXXXXXXX', 'X'],
      textTransform: TextTransformOption.Uppercase,
    }
  }

  if (insurance?.slug === 'carrefour-fid') {
    return {
      patterns: [-1],
      valueSeparator: '',
      placeholders: [`Numéro ${uncapitalizeSentence(insurance?.name)}`],
      textTransform: TextTransformOption.None,
    }
  }

  return {
    patterns: [-1],
    valueSeparator: '',
    placeholders: [`${capitalizeSentence(insurance?.name as string)}`],
    textTransform: TextTransformOption.None,
  }
}
